import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { BookOpen, Heart, Mail, ExternalLink } from 'lucide-react';

export function AboutDialog({ open, onOpenChange }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md overflow-hidden p-0">
        <div className="relative bg-gradient-to-br from-primary/15 via-card to-card px-6 py-8">
          <div className="absolute inset-0 texture-grid opacity-30" />
          <div className="relative flex items-center gap-3">
            <div className="flex h-12 w-12 items-center justify-center rounded-md bg-primary text-primary-foreground shadow-inset-top">
              <BookOpen className="h-6 w-6" />
            </div>
            <div>
              <div className="text-[12px] uppercase tracking-[0.2em] text-muted-foreground">The Loom</div>
              <div className="text-2xl font-semibold tracking-tight text-foreground">Version 2.0</div>
              <div className="text-[11.5px] text-muted-foreground">Build 2026.01.142 · Windows desktop · 64-bit</div>
            </div>
          </div>
        </div>

        <div className="px-6 py-5">
          <DialogHeader>
            <DialogTitle className="text-[14px]">A long-form novel studio for Claude AI</DialogTitle>
          <DialogDescription className="sr-only">Information about The Loom V2.38_f55, author, license, and contact.</DialogDescription>
          </DialogHeader>
          <p className="mt-2 text-[12.5px] leading-relaxed text-muted-foreground">
            The Loom integrates Anthropic’s Claude Sonnet 4.5 to draft, revise, and analyze novels of 50,000–80,000 words across 20 chapters — with editable variables, an integrated character bible, arc visualization, and continuity analysis.
          </p>

          <div className="mt-5 grid grid-cols-2 gap-2 text-[11.5px]">
            <Stat k="Copyright"   v="© 2026 Crown & Rose LLC" />
            <Stat k="License"     v="All Rights Reserved" />
            <Stat k="AI Engine"   v="Claude Sonnet 4.5" />
            <Stat k="Made with"   v=<span className="inline-flex items-center gap-1">EB Garamond &amp; <Heart className="h-3 w-3 text-destructive" /></span> />
          </div>

          <div className="mt-4 rounded-md border border-border bg-panel-header/40 p-3 text-[11.5px]">
            <div className="text-muted-foreground">Contact us</div>
            <a href="mailto:info@crownnrose.com" className="mt-1 inline-flex items-center gap-1.5 font-medium text-primary hover:underline">
              <Mail className="h-3.5 w-3.5" /> info@crownnrose.com <ExternalLink className="h-3 w-3" />
            </a>
          </div>
        </div>

        <DialogFooter className="border-t border-border bg-panel-header/40 px-5 py-3">
          <Button size="sm" onClick={() => onOpenChange(false)}>Close</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}

function Stat({ k, v }) {
  return (
    <div className="rounded-md border border-border bg-card px-2.5 py-2">
      <div className="text-[10px] uppercase tracking-wider text-muted-foreground">{k}</div>
      <div className="text-[12.5px] font-medium text-foreground">{v}</div>
    </div>
  );
}
